import { useMutation } from "@apollo/client/react";
import { REJECT_INVOICES } from "../../mutations/invoices/rejectInvoices";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import GET_CLIENTS_WITH_INVOICES from "../../queries/invoices/getClientsWithInvoices";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";

export const useRejectInvoices = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [rejectInvoices, { data, loading, error }] = useMutation(
    REJECT_INVOICES,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [
        GET_INVOICE_LATEST_VALIDATION_RESULT,
        GET_CLIENTS_WITH_INVOICES,
        GET_CLIENT_INVOICES,
      ],
      awaitRefetchQueries: true,
    },
  );

  return { rejectInvoices, data, loading, error };
};
